/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsEbsVolumeRestoreData } from '../models/AwsEbsVolumeRestoreData';
import { AzureDiskRestoreData } from '../models/AzureDiskRestoreData';
import { FileRestoreData } from '../models/FileRestoreData';
import { GcpDiskRestoreData } from '../models/GcpDiskRestoreData';
import { PartialRestoreType } from '../models/PartialRestoreType';

/**
* Restored resource properties. The properties present in this object change depending on the value set in `restoreType`. 
*/
export class PartialRestoreData {
  'partialRestoreType': PartialRestoreType;
  'files'?: FileRestoreData | null;
  'awsEbsVolume'?: AwsEbsVolumeRestoreData | null;
  'azureDisk'?: AzureDiskRestoreData | null;
  'gcpDisk'?: GcpDiskRestoreData | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "partialRestoreType",
      "baseName": "partialRestoreType",
      "type": "PartialRestoreType",
      "format": ""
    },
    {
      "name": "files",
      "baseName": "files",
      "type": "FileRestoreData",
      "format": ""
    },
    {
      "name": "awsEbsVolume",
      "baseName": "awsEbsVolume",
      "type": "AwsEbsVolumeRestoreData",
      "format": ""
    },
    {
      "name": "azureDisk",
      "baseName": "azureDisk",
      "type": "AzureDiskRestoreData",
      "format": ""
    },
    {
      "name": "gcpDisk",
      "baseName": "gcpDisk",
      "type": "GcpDiskRestoreData",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return PartialRestoreData.attributeTypeMap;
  }

  public constructor() {
  }
}



